import "./Styles/main.scss";
import { Slick } from "@/pages/vendors/vendor.slick";
import { cmsGlobal } from "@/common/fhtGlobalEnv";
import { KnownCmsPageType } from "@/api";
import { createAniView } from "@/pages/vendors/vendor.aniView";

$(async function () {
    createAniView($(".aniview"));

    const slidesbanners = new Slick($(".slides-banners"), {
        dots: true,
        arrows: false,
        autoplaySpeed: 5000,
    });
    slidesbanners.slickPlay();

    if (cmsGlobal.Cms.IsCustomDomain && cmsGlobal.KnownPage === KnownCmsPageType.CmsProductDetail) {
        import(/* webpackChunkName: "imagePhotoswipe" */ "../../pages/modules/imagePhotoswipe");
    }

    //TODO only primary template 2 has this???
    const hotproducts = new Slick($(".hot-products"), {
        dots: true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 3000,
        fade: false,
        autoplay: true,
        cssEase: "linear",
        arrows: false,
    });
    hotproducts.slickPlay();
});
